// Mock data pour le site Orion Industrie - Équipements de quai et sécurité industrielle

export const companyInfo = {
  name: "Orion Industrie",
  tagline: "Sécuriser • Équiper • Fiabiliser",
  baseline: "Équipements de quai & sécurité industrielle",
  description: "Spécialiste de l'installation et maintenance d'équipements de quai dans le respect des normes de sécurité au travail.",
  foundedYear: "2019",
  phone: "06 59 45 25 62",
  email: "gestion@orion-industrie.eu",
  domain: "orion-industrie.eu",
  address: "France",
  siret: "105 168 207 00014",
  legalForm: "EURL"
};

export const heroContent = {
  title: "Sécurisez vos quais, protégez vos équipes",
  subtitle: "Équipements professionnels pour la sécurité de vos collaborateurs",
  description: "Orion Industrie vous accompagne dans la mise en conformité de vos installations logistiques avec des équipements de qualité supérieure et un service d'installation rapide. Notre principal objectif : une utilisation simple qui assure la sécurité de tous, chauffeurs comme collaborateurs sur quais.",
  cta: "Demander un devis",
  ctaSecondary: "Nos produits"
};

export const products = [
  {
    id: 1,
    name: "Pont Hydraulique / Niveleur Hydraulique",
    category: "Niveleur de quai",
    price: "sur_devis",
    priceUnit: "",
    priceLabel: "Sur devis",
    description: "Notre produit phare : pont hydraulique (niveleur hydraulique) conforme à toutes les normes Carsat et de sécurité au travail. Adaptable à presque toutes les configurations de quais, sans nécessiter de maçonnerie. Solution robuste et fiable pour vos opérations de chargement et déchargement.",
    features: [
      "Fabrication française",
      "Adaptable à toutes configurations de quais",
      "Sans maçonnerie nécessaire",
      "Zone de survie 500mm",
      "Conforme aux recommandations de prévention",
      "Installation rapide",
      "Maintenance facilitée",
      "Garantie constructeur"
    ],
    image: "https://customer-assets.emergentagent.com/job_tranship-solutions/artifacts/oytx1a5m_9C82620C-3241-4100-93E2-1CB893EDE6C8.png",
    featured: true
  },
  {
    id: 2,
    name: "Butoirs de Quai",
    category: "Protection",
    price: "810",
    priceUnit: "€ HT",
    priceLabel: "À partir de",
    description: "Butoirs robustes brevetés pour protéger vos installations et garantir la sécurité des manœuvres de chargement. Garantie 7 ans.",
    features: [
      "Breveté",
      "Garantie 7 ans",
      "Résistance aux chocs",
      "Installation sur mesure",
      "Fabrication française",
      "Durabilité garantie"
    ],
    image: "/images/butoirs.jpg",
    featured: false
  },
  {
    id: 3,
    name: "Gardes-Corps de Sécurité",
    category: "Sécurité",
    price: "sur_devis",
    priceUnit: "",
    priceLabel: "Sur devis",
    description: "Gardes-corps conformes aux normes de sécurité pour protéger vos équipes lors des opérations de manutention.",
    features: [
      "Conformité réglementaire",
      "Protection optimale",
      "Installation professionnelle",
      "Fabrication française"
    ],
    image: "/images/garde-corps.jpg",
    featured: false
  },
  {
    id: 4,
    name: "Ponts Aluminium ou Acier",
    category: "Transbordement",
    price: "sur_devis",
    priceUnit: "",
    priceLabel: "Sur devis",
    description: "Solutions complètes de ponts aluminium ou acier pour faciliter vos opérations de transbordement en toute sécurité.",
    features: [
      "Aluminium ou Acier",
      "Capacité adaptable",
      "Zone de survie 500mm",
      "Fabrication française",
      "SAV réactif"
    ],
    image: "/images/pont-transbordement.jpg",
    featured: false
  },
  {
    id: 5,
    name: "Barrières Pivotantes / Barrières Levantes",
    category: "Sécurité",
    price: "sur_devis",
    priceUnit: "",
    priceLabel: "Sur devis",
    description: "Barrières de sécurité amovibles qui bloquent les accès au nez de quai pour éviter les chutes de plain-pied, tout en restant modulables pour ne pas entraver le transbordement ou le passage piéton. Disponibles en version pivotante simple ou avec signalisation STOP intégrée.",
    features: [
      "Protection anti-chute",
      "Système amovible/pivotant",
      "Haute visibilité (jaune)",
      "Signalisation STOP (option)",
      "Conformité normes sécurité",
      "Fabrication française",
      "Installation rapide",
      "Ne gêne pas les opérations"
    ],
    images: [
      {
        url: "https://res.cloudinary.com/dtswbmizy/image/upload/v1774943045/b2m-products/barriere-levante.jpg",
        alt: "Barrière levante jaune - Version simple",
        type: "levante"
      },
      {
        url: "https://res.cloudinary.com/dtswbmizy/image/upload/v1774943047/b2m-products/barriere-pivotante.jpg",
        alt: "Barrière pivotante avec panneaux STOP - Version renforcée",
        type: "pivotante"
      }
    ],
    image: "https://res.cloudinary.com/dtswbmizy/image/upload/v1774943045/b2m-products/barriere-levante.jpg",
    hasMultipleImages: true,
    featured: false
  }
];

export const advantages = [
  {
    id: 1,
    icon: "Shield",
    title: "Normes de sécurité",
    description: "Nos équipements sont installés dans le respect des normes de sécurité au travail pour protéger vos collaborateurs."
  },
  {
    id: 2,
    icon: "Zap",
    title: "Installation rapide - Neuf & rénovation",
    description: "Intervention express sur chantiers neufs ou en rénovation. Notre matériel de pose autonome (groupe électrogène) nous permet d'intervenir même sans électricité sur site : pas d'attente de l'électricien, votre chantier avance."
  },
  {
    id: 3,
    icon: "Award",
    title: "Équipements brevetés et fabrication française",
    description: "Équipements robustes et durables, conçus pour résister aux conditions les plus exigeantes."
  },
  {
    id: 4,
    icon: "Wrench",
    title: "SAV Réactif",
    description: "Réponse rapide pour planifier une intervention ou la maintenance de vos équipements et assurer la continuité de votre activité"
  },
  {
    id: 5,
    icon: "ClipboardCheck",
    title: "Diagnostic sur site",
    description: "Évaluation de vos installations pour identifier les besoins de mise en conformité et d'optimisation de votre sécurité."
  }
];

export const services = [
  {
    id: 1,
    title: "Mise aux Normes",
    description: "Audit et mise en conformité de vos équipements existants selon les dernières réglementations Carsat."
  },
  {
    id: 2,
    title: "Installation",
    description: "Pose professionnelle de vos nouveaux équipements de quai par nos techniciens qualifiés."
  },
  {
    id: 3,
    title: "Maintenance",
    description: "Contrats de maintenance préventive et curative pour garantir la longévité de vos installations."
  },
  {
    id: 4,
    title: "Conseil",
    description: "Accompagnement personnalisé pour choisir les solutions les plus adaptées à vos besoins."
  }
];

export const equipmentTypes = [
  { value: "pont-hydraulique", label: "Pont Hydraulique" },
  { value: "butoir", label: "Butoir de Quai" },
  { value: "garde-corps", label: "Garde-Corps" },
  { value: "pont-transbordement", label: "Pont de Transbordement" },
  { value: "autre", label: "Autre équipement" }
];

export const dockHeights = [
  { value: "moins-80", label: "Moins de 80 cm" },
  { value: "90", label: "90 cm" },
  { value: "100", label: "100 cm" },
  { value: "110", label: "110 cm" },
  { value: "120", label: "120 cm" },
  { value: "plus-120", label: "Plus de 120 cm" }
];

// Base de données codes postaux français avec villes associées
export const frenchPostalCodes = [
  // Île-de-France - Paris (75)
  { postalCode: "75001", city: "Paris 1er" },
  { postalCode: "75002", city: "Paris 2e" },
  { postalCode: "75003", city: "Paris 3e" },
  { postalCode: "75004", city: "Paris 4e" },
  { postalCode: "75005", city: "Paris 5e" },
  { postalCode: "75006", city: "Paris 6e" },
  { postalCode: "75007", city: "Paris 7e" },
  { postalCode: "75008", city: "Paris 8e" },
  { postalCode: "75009", city: "Paris 9e" },
  { postalCode: "75010", city: "Paris 10e" },
  { postalCode: "75011", city: "Paris 11e" },
  { postalCode: "75012", city: "Paris 12e" },
  { postalCode: "75013", city: "Paris 13e" },
  { postalCode: "75014", city: "Paris 14e" },
  { postalCode: "75015", city: "Paris 15e" },
  { postalCode: "75016", city: "Paris 16e" },
  { postalCode: "75017", city: "Paris 17e" },
  { postalCode: "75018", city: "Paris 18e" },
  { postalCode: "75019", city: "Paris 19e" },
  { postalCode: "75020", city: "Paris 20e" },
  
  // Yvelines (78)
  { postalCode: "78000", city: "Versailles" },
  { postalCode: "78100", city: "Saint-Germain-en-Laye" },
  { postalCode: "78200", city: "Mantes-la-Jolie" },
  { postalCode: "78300", city: "Poissy" },
  { postalCode: "78400", city: "Chatou" },
  { postalCode: "78500", city: "Sartrouville" },
  
  // Essonne (91)
  { postalCode: "91000", city: "Évry-Courcouronnes" },
  { postalCode: "91100", city: "Corbeil-Essonnes" },
  { postalCode: "91200", city: "Athis-Mons" },
  { postalCode: "91300", city: "Massy" },
  { postalCode: "91400", city: "Orsay" },
  
  // Hauts-de-Seine (92)
  { postalCode: "92000", city: "Nanterre" },
  { postalCode: "92100", city: "Boulogne-Billancourt" },
  { postalCode: "92200", city: "Neuilly-sur-Seine" },
  { postalCode: "92300", city: "Levallois-Perret" },
  { postalCode: "92400", city: "Courbevoie" },
  { postalCode: "92500", city: "Rueil-Malmaison" },
  { postalCode: "92600", city: "Asnières-sur-Seine" },
  
  // Seine-Saint-Denis (93)
  { postalCode: "93000", city: "Bobigny" },
  { postalCode: "93100", city: "Montreuil" },
  { postalCode: "93200", city: "Saint-Denis" },
  { postalCode: "93300", city: "Aubervilliers" },
  { postalCode: "93400", city: "Saint-Ouen-sur-Seine" },
  { postalCode: "93500", city: "Pantin" },
  
  // Val-de-Marne (94)
  { postalCode: "94000", city: "Créteil" },
  { postalCode: "94100", city: "Saint-Maur-des-Fossés" },
  { postalCode: "94200", city: "Ivry-sur-Seine" },
  { postalCode: "94300", city: "Vincennes" },
  { postalCode: "94400", city: "Vitry-sur-Seine" },
  
  // Val-d'Oise (95)
  { postalCode: "95000", city: "Cergy" },
  { postalCode: "95100", city: "Argenteuil" },
  { postalCode: "95200", city: "Sarcelles" },
  { postalCode: "95300", city: "Pontoise" },
  { postalCode: "95400", city: "Villiers-le-Bel" },
  
  // Seine-et-Marne (77)
  { postalCode: "77000", city: "Melun" },
  { postalCode: "77100", city: "Meaux" },
  { postalCode: "77200", city: "Torcy" },
  { postalCode: "77300", city: "Fontainebleau" },
  { postalCode: "77400", city: "Lagny-sur-Marne" },
  { postalCode: "77500", city: "Chelles" },
  
  // Rhône (69)
  { postalCode: "69001", city: "Lyon 1er" },
  { postalCode: "69002", city: "Lyon 2e" },
  { postalCode: "69003", city: "Lyon 3e" },
  { postalCode: "69004", city: "Lyon 4e" },
  { postalCode: "69005", city: "Lyon 5e" },
  { postalCode: "69006", city: "Lyon 6e" },
  { postalCode: "69007", city: "Lyon 7e" },
  { postalCode: "69008", city: "Lyon 8e" },
  { postalCode: "69009", city: "Lyon 9e" },
  { postalCode: "69100", city: "Villeurbanne" },
  { postalCode: "69200", city: "Vénissieux" },
  { postalCode: "69300", city: "Caluire-et-Cuire" },
  { postalCode: "69400", city: "Villefranche-sur-Saône" },
  { postalCode: "69500", city: "Bron" },
  
  // Isère (38)
  { postalCode: "38000", city: "Grenoble" },
  { postalCode: "38100", city: "Grenoble" },
  { postalCode: "38200", city: "Vienne" },
  { postalCode: "38300", city: "Bourgoin-Jallieu" },
  { postalCode: "38400", city: "Saint-Martin-d'Hères" },
  { postalCode: "38500", city: "Voiron" },
  
  // Loire (42)
  { postalCode: "42000", city: "Saint-Étienne" },
  { postalCode: "42100", city: "Saint-Étienne" },
  { postalCode: "42300", city: "Roanne" },
  { postalCode: "42400", city: "Saint-Chamond" },
  { postalCode: "42500", city: "Le Chambon-Feugerolles" },
  
  // Puy-de-Dôme (63)
  { postalCode: "63000", city: "Clermont-Ferrand" },
  { postalCode: "63100", city: "Clermont-Ferrand" },
  { postalCode: "63200", city: "Riom" },
  { postalCode: "63300", city: "Thiers" },
  { postalCode: "63400", city: "Chamalières" },
  
  // Savoie (73)
  { postalCode: "73000", city: "Chambéry" },
  { postalCode: "73100", city: "Aix-les-Bains" },
  { postalCode: "73200", city: "Albertville" },
  { postalCode: "73300", city: "Saint-Jean-de-Maurienne" },
  
  // Haute-Savoie (74)
  { postalCode: "74000", city: "Annecy" },
  { postalCode: "74100", city: "Annemasse" },
  { postalCode: "74200", city: "Thonon-les-Bains" },
  { postalCode: "74300", city: "Cluses" },
  { postalCode: "74400", city: "Chamonix-Mont-Blanc" },
  
  // Gironde (33)
  { postalCode: "33000", city: "Bordeaux" },
  { postalCode: "33100", city: "Bordeaux" },
  { postalCode: "33200", city: "Bordeaux" },
  { postalCode: "33300", city: "Bordeaux" },
  { postalCode: "33400", city: "Talence" },
  { postalCode: "33500", city: "Libourne" },
  { postalCode: "33600", city: "Pessac" },
  { postalCode: "33700", city: "Mérignac" },
  
  // Haute-Vienne (87)
  { postalCode: "87000", city: "Limoges" },
  { postalCode: "87100", city: "Limoges" },
  { postalCode: "87200", city: "Saint-Junien" },
  { postalCode: "87280", city: "Limoges" },
  
  // Vienne (86)
  { postalCode: "86000", city: "Poitiers" },
  { postalCode: "86100", city: "Châtellerault" },
  { postalCode: "86200", city: "Loudun" },
  { postalCode: "86300", city: "Chauvigny" },
  
  // Charente-Maritime (17)
  { postalCode: "17000", city: "La Rochelle" },
  { postalCode: "17100", city: "Saintes" },
  { postalCode: "17200", city: "Royan" },
  { postalCode: "17300", city: "Rochefort" },
  { postalCode: "17400", city: "Saint-Jean-d'Angély" },
  
  // Dordogne (24)
  { postalCode: "24000", city: "Périgueux" },
  { postalCode: "24100", city: "Bergerac" },
  { postalCode: "24200", city: "Sarlat-la-Canéda" },
  
  // Landes (40)
  { postalCode: "40000", city: "Mont-de-Marsan" },
  { postalCode: "40100", city: "Dax" },
  { postalCode: "40200", city: "Mimizan" },
  { postalCode: "40600", city: "Biscarrosse" },
  
  // Pyrénées-Atlantiques (64)
  { postalCode: "64000", city: "Pau" },
  { postalCode: "64100", city: "Bayonne" },
  { postalCode: "64200", city: "Biarritz" },
  { postalCode: "64300", city: "Orthez" },
  
  // Haute-Garonne (31)
  { postalCode: "31000", city: "Toulouse" },
  { postalCode: "31100", city: "Toulouse" },
  { postalCode: "31200", city: "Toulouse" },
  { postalCode: "31300", city: "Toulouse" },
  { postalCode: "31400", city: "Toulouse" },
  { postalCode: "31500", city: "Toulouse" },
  { postalCode: "31600", city: "Muret" },
  { postalCode: "31700", city: "Blagnac" },
  { postalCode: "31800", city: "Saint-Gaudens" },
  
  // Hérault (34)
  { postalCode: "34000", city: "Montpellier" },
  { postalCode: "34070", city: "Montpellier" },
  { postalCode: "34080", city: "Montpellier" },
  { postalCode: "34090", city: "Montpellier" },
  { postalCode: "34100", city: "Montpellier" },
  { postalCode: "34200", city: "Sète" },
  { postalCode: "34300", city: "Agde" },
  { postalCode: "34400", city: "Lunel" },
  { postalCode: "34500", city: "Béziers" },
  
  // Pyrénées-Orientales (66)
  { postalCode: "66000", city: "Perpignan" },
  { postalCode: "66100", city: "Perpignan" },
  { postalCode: "66200", city: "Elne" },
  { postalCode: "66300", city: "Thuir" },
  { postalCode: "66400", city: "Céret" },
  
  // Gard (30)
  { postalCode: "30000", city: "Nîmes" },
  { postalCode: "30100", city: "Alès" },
  { postalCode: "30200", city: "Bagnols-sur-Cèze" },
  { postalCode: "30300", city: "Beaucaire" },
  { postalCode: "30900", city: "Nîmes" },
  
  // Nord (59)
  { postalCode: "59000", city: "Lille" },
  { postalCode: "59100", city: "Roubaix" },
  { postalCode: "59200", city: "Tourcoing" },
  { postalCode: "59300", city: "Valenciennes" },
  { postalCode: "59400", city: "Cambrai" },
  { postalCode: "59500", city: "Douai" },
  { postalCode: "59600", city: "Maubeuge" },
  { postalCode: "59700", city: "Marcq-en-Barœul" },
  { postalCode: "59800", city: "Lille" },
  { postalCode: "59140", city: "Dunkerque" },
  { postalCode: "59240", city: "Dunkerque" },
  
  // Somme (80)
  { postalCode: "80000", city: "Amiens" },
  { postalCode: "80100", city: "Abbeville" },
  { postalCode: "80200", city: "Péronne" },
  { postalCode: "80300", city: "Albert" },
  
  // Pas-de-Calais (62)
  { postalCode: "62000", city: "Arras" },
  { postalCode: "62100", city: "Calais" },
  { postalCode: "62200", city: "Boulogne-sur-Mer" },
  { postalCode: "62300", city: "Lens" },
  { postalCode: "62400", city: "Béthune" },
  { postalCode: "62500", city: "Saint-Omer" },
  
  // Oise (60)
  { postalCode: "60000", city: "Beauvais" },
  { postalCode: "60100", city: "Creil" },
  { postalCode: "60200", city: "Compiègne" },
  { postalCode: "60300", city: "Senlis" },
  
  // Aisne (02)
  { postalCode: "02000", city: "Laon" },
  { postalCode: "02100", city: "Saint-Quentin" },
  { postalCode: "02200", city: "Soissons" },
  { postalCode: "02300", city: "Chauny" },
  
  // Bas-Rhin (67)
  { postalCode: "67000", city: "Strasbourg" },
  { postalCode: "67100", city: "Strasbourg" },
  { postalCode: "67200", city: "Strasbourg" },
  { postalCode: "67300", city: "Schiltigheim" },
  { postalCode: "67400", city: "Illkirch-Graffenstaden" },
  { postalCode: "67500", city: "Haguenau" },
  
  // Marne (51)
  { postalCode: "51100", city: "Reims" },
  { postalCode: "51000", city: "Châlons-en-Champagne" },
  { postalCode: "51200", city: "Épernay" },
  { postalCode: "51300", city: "Vitry-le-François" },
  
  // Moselle (57)
  { postalCode: "57000", city: "Metz" },
  { postalCode: "57100", city: "Thionville" },
  { postalCode: "57200", city: "Sarreguemines" },
  { postalCode: "57300", city: "Hagondange" },
  { postalCode: "57400", city: "Sarrebourg" },
  
  // Meurthe-et-Moselle (54)
  { postalCode: "54000", city: "Nancy" },
  { postalCode: "54100", city: "Nancy" },
  { postalCode: "54200", city: "Toul" },
  { postalCode: "54300", city: "Lunéville" },
  { postalCode: "54400", city: "Longwy" },
  
  // Haut-Rhin (68)
  { postalCode: "68000", city: "Colmar" },
  { postalCode: "68100", city: "Mulhouse" },
  { postalCode: "68200", city: "Mulhouse" },
  { postalCode: "68300", city: "Saint-Louis" },
  
  // Bouches-du-Rhône (13)
  { postalCode: "13001", city: "Marseille 1er" },
  { postalCode: "13002", city: "Marseille 2e" },
  { postalCode: "13003", city: "Marseille 3e" },
  { postalCode: "13004", city: "Marseille 4e" },
  { postalCode: "13005", city: "Marseille 5e" },
  { postalCode: "13006", city: "Marseille 6e" },
  { postalCode: "13007", city: "Marseille 7e" },
  { postalCode: "13008", city: "Marseille 8e" },
  { postalCode: "13009", city: "Marseille 9e" },
  { postalCode: "13010", city: "Marseille 10e" },
  { postalCode: "13100", city: "Aix-en-Provence" },
  { postalCode: "13200", city: "Arles" },
  { postalCode: "13300", city: "Salon-de-Provence" },
  { postalCode: "13400", city: "Aubagne" },
  { postalCode: "13500", city: "Martigues" },
  
  // Alpes-Maritimes (06)
  { postalCode: "06000", city: "Nice" },
  { postalCode: "06100", city: "Nice" },
  { postalCode: "06200", city: "Nice" },
  { postalCode: "06300", city: "Nice" },
  { postalCode: "06400", city: "Cannes" },
  { postalCode: "06500", city: "Menton" },
  { postalCode: "06600", city: "Antibes" },
  
  // Var (83)
  { postalCode: "83000", city: "Toulon" },
  { postalCode: "83100", city: "Toulon" },
  { postalCode: "83200", city: "Toulon" },
  { postalCode: "83300", city: "Draguignan" },
  { postalCode: "83400", city: "Hyères" },
  { postalCode: "83500", city: "La Seyne-sur-Mer" },
  { postalCode: "83600", city: "Fréjus" },
  
  // Vaucluse (84)
  { postalCode: "84000", city: "Avignon" },
  { postalCode: "84100", city: "Orange" },
  { postalCode: "84200", city: "Carpentras" },
  { postalCode: "84300", city: "Cavaillon" },
  
  // Ille-et-Vilaine (35)
  { postalCode: "35000", city: "Rennes" },
  { postalCode: "35100", city: "Rennes" },
  { postalCode: "35200", city: "Rennes" },
  { postalCode: "35300", city: "Fougères" },
  { postalCode: "35400", city: "Saint-Malo" },
  { postalCode: "35500", city: "Vitré" },
  
  // Finistère (29)
  { postalCode: "29000", city: "Quimper" },
  { postalCode: "29200", city: "Brest" },
  { postalCode: "29100", city: "Douarnenez" },
  { postalCode: "29300", city: "Quimperlé" },
  { postalCode: "29400", city: "Landivisiau" },
  { postalCode: "29600", city: "Morlaix" },
  
  // Côtes-d'Armor (22)
  { postalCode: "22000", city: "Saint-Brieuc" },
  { postalCode: "22100", city: "Dinan" },
  { postalCode: "22200", city: "Guingamp" },
  { postalCode: "22300", city: "Lannion" },
  
  // Morbihan (56)
  { postalCode: "56000", city: "Vannes" },
  { postalCode: "56100", city: "Lorient" },
  { postalCode: "56200", city: "La Gacilly" },
  { postalCode: "56300", city: "Pontivy" },
  { postalCode: "56400", city: "Auray" },
  
  // Loire-Atlantique (44)
  { postalCode: "44000", city: "Nantes" },
  { postalCode: "44100", city: "Nantes" },
  { postalCode: "44200", city: "Nantes" },
  { postalCode: "44300", city: "Nantes" },
  { postalCode: "44400", city: "Rezé" },
  { postalCode: "44600", city: "Saint-Nazaire" },
  { postalCode: "44800", city: "Saint-Herblain" },
  
  // Maine-et-Loire (49)
  { postalCode: "49000", city: "Angers" },
  { postalCode: "49100", city: "Angers" },
  { postalCode: "49300", city: "Cholet" },
  { postalCode: "49400", city: "Saumur" },
  
  // Sarthe (72)
  { postalCode: "72000", city: "Le Mans" },
  { postalCode: "72100", city: "Le Mans" },
  { postalCode: "72200", city: "La Flèche" },
  { postalCode: "72300", city: "Sablé-sur-Sarthe" },
  
  // Vendée (85)
  { postalCode: "85000", city: "La Roche-sur-Yon" },
  { postalCode: "85100", city: "Les Sables-d'Olonne" },
  { postalCode: "85200", city: "Fontenay-le-Comte" },
  { postalCode: "85300", city: "Challans" },
  
  // Seine-Maritime (76)
  { postalCode: "76000", city: "Rouen" },
  { postalCode: "76100", city: "Rouen" },
  { postalCode: "76600", city: "Le Havre" },
  { postalCode: "76200", city: "Dieppe" },
  { postalCode: "76300", city: "Sotteville-lès-Rouen" },
  { postalCode: "76400", city: "Fécamp" },
  
  // Calvados (14)
  { postalCode: "14000", city: "Caen" },
  { postalCode: "14100", city: "Lisieux" },
  { postalCode: "14200", city: "Hérouville-Saint-Clair" },
  { postalCode: "14400", city: "Bayeux" },
  { postalCode: "14500", city: "Vire" },
  
  // Eure (27)
  { postalCode: "27000", city: "Évreux" },
  { postalCode: "27100", city: "Val-de-Reuil" },
  { postalCode: "27200", city: "Vernon" },
  { postalCode: "27300", city: "Bernay" },
  
  // Côte-d'Or (21)
  { postalCode: "21000", city: "Dijon" },
  { postalCode: "21200", city: "Beaune" },
  { postalCode: "21300", city: "Chenôve" },
  { postalCode: "21400", city: "Châtillon-sur-Seine" },
  
  // Doubs (25)
  { postalCode: "25000", city: "Besançon" },
  { postalCode: "25200", city: "Montbéliard" },
  { postalCode: "25300", city: "Pontarlier" },
  { postalCode: "25400", city: "Audincourt" },
  
  // Nièvre (58)
  { postalCode: "58000", city: "Nevers" },
  { postalCode: "58200", city: "Cosne-Cours-sur-Loire" },
  { postalCode: "58300", city: "Decize" },
  { postalCode: "58400", city: "La Charité-sur-Loire" },
  
  // Yonne (89)
  { postalCode: "89000", city: "Auxerre" },
  { postalCode: "89100", city: "Sens" },
  { postalCode: "89200", city: "Avallon" },
  { postalCode: "89300", city: "Joigny" },
  
  // Loiret (45)
  { postalCode: "45000", city: "Orléans" },
  { postalCode: "45100", city: "Orléans" },
  { postalCode: "45200", city: "Montargis" },
  { postalCode: "45300", city: "Pithiviers" },
  { postalCode: "45400", city: "Fleury-les-Aubrais" },
  
  // Indre-et-Loire (37)
  { postalCode: "37000", city: "Tours" },
  { postalCode: "37100", city: "Tours" },
  { postalCode: "37200", city: "Tours" },
  { postalCode: "37300", city: "Joué-lès-Tours" },
  { postalCode: "37400", city: "Amboise" },
  { postalCode: "37500", city: "Chinon" },
  
  // Cher (18)
  { postalCode: "18000", city: "Bourges" },
  { postalCode: "18100", city: "Vierzon" },
  { postalCode: "18200", city: "Saint-Amand-Montrond" },
  
  // Eure-et-Loir (28)
  { postalCode: "28000", city: "Chartres" },
  { postalCode: "28100", city: "Dreux" },
  { postalCode: "28200", city: "Châteaudun" },
  { postalCode: "28300", city: "Mainvilliers" },
  
  // Corse-du-Sud (2A)
  { postalCode: "20000", city: "Ajaccio" },
  { postalCode: "20090", city: "Ajaccio" },
  { postalCode: "20100", city: "Sartène" },
  { postalCode: "20110", city: "Propriano" },
  
  // Haute-Corse (2B)
  { postalCode: "20200", city: "Bastia" },
  { postalCode: "20250", city: "Corte" },
  { postalCode: "20260", city: "Calvi" },
  { postalCode: "20600", city: "Bastia" }
];

// Galerie de réalisations
export const galleryItems = [
  {
    id: 1,
    image: "/images/gallery/chantier-1.jpg",
    title: "Installation complète de ponts hydrauliques",
    location: "Plateforme logistique - Région parisienne",
    type: "Ponts hydrauliques",
    year: "2024",
    description: "Installation de 10 ponts hydrauliques avec bandes de sécurité"
  },
  {
    id: 2,
    image: "/images/gallery/chantier-2.jpg",
    title: "Niveleur de quai industriel",
    location: "Entrepôt frigorifique",
    type: "Pont niveleur",
    year: "2024",
    description: "Pont niveleur avec butoirs intégrés"
  },
  {
    id: 3,
    image: "/images/gallery/chantier-3.jpg",
    title: "Installation multiple quais de chargement",
    location: "Centre de distribution",
    type: "Sas d'étanchéité & Ponts",
    year: "2023",
    description: "6 postes de chargement avec sas d'étanchéité et ponts hydrauliques"
  },
  {
    id: 4,
    image: "/images/gallery/chantier-4.jpg",
    title: "Mise aux normes Carsat",
    location: "Base logistique",
    type: "Pont hydraulique",
    year: "2023",
    description: "Remplacement d'équipement vétuste et mise en conformité"
  },
  {
    id: 5,
    image: "/images/gallery/chantier-5.jpg",
    title: "Niveleur avec rampes d'accès",
    location: "Entrepôt pharmaceutique",
    type: "Système complet",
    year: "2024",
    description: "Installation avec rampes et butoirs de sécurité"
  },
  {
    id: 6,
    image: "/images/gallery/chantier-6.jpg",
    title: "Quais de chargement avec protections renforcées",
    location: "Entrepôt logistique",
    type: "Protections & Sas",
    year: "2024",
    description: "Installation de protections jaunes et marquages au sol conformes"
  },
  {
    id: 7,
    image: "/images/gallery/chantier-7.jpg",
    title: "Installation grande capacité - 11 quais",
    location: "Hub logistique moderne",
    type: "Installation complète",
    year: "2024",
    description: "Projet d'envergure avec 11 postes de chargement numérotés"
  },
  {
    id: 8,
    image: "/images/gallery/chantier-8.jpg",
    title: "Centre GLS - Installation complète",
    location: "Plateforme GLS",
    type: "Sas d'étanchéité bleus",
    year: "2023",
    description: "Installation de sas d'étanchéité et équipements de quai pour GLS"
  },
  {
    id: 9,
    image: "/images/gallery/chantier-9.jpg",
    title: "Ponts hydrauliques LS Loading Systems",
    location: "Site industriel",
    type: "Ponts bleus professionnels",
    year: "2023",
    description: "Installation de ponts hydrauliques LS avec protections latérales"
  },
  {
    id: 10,
    image: "/images/gallery/chantier-10.jpg",
    title: "Systèmes de chargement double",
    location: "Plateforme e-commerce",
    type: "Ponts doubles",
    year: "2024",
    description: "2 ponts LS Loading Systems avec sas d'étanchéité bleus"
  }
];


// Mock pour soumission de formulaires - REMPLACÉ PAR VRAIES APIs
export const submitContactForm = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  const response = await fetch(`${BACKEND_URL}/api/contact`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(formData),
  });
  
  if (!response.ok) {
    throw new Error('Erreur lors de l\'envoi du message');
  }
  
  return await response.json();
};

export const submitQuoteForm = async (formData) => {
  const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
  
  // Map frontend field names to backend field names
  const backendData = {
    company: formData.company,
    name: formData.name,
    email: formData.email,
    phone: formData.phone,
    equipment_type: formData.equipmentType,  // camelCase -> snake_case
    dock_height: formData.dockHeight,        // camelCase -> snake_case
    quantity: parseInt(formData.quantity) || 1,   // Ensure it's a number, default to 1
    address: formData.location || formData.address,  // Use location field
    details: formData.details || '',
    recaptchaToken: formData.recaptchaToken  // Include reCAPTCHA token
  };
  
  const response = await fetch(`${BACKEND_URL}/api/quote`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(backendData),
  });
  
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.detail || 'Erreur lors de l\'envoi de la demande de devis');
  }
  
  return await response.json();
};
